<template>
  <v-snackbar top v-model="snackShow" :color="color">
    <div class="white--text">
      {{ message }}
    </div>
    <div class="v-menu__content--active" style="display:none; z-index:2;" />
  </v-snackbar>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  computed: {
    // v-model del v-snackbar necesita setter: Vuetify lo pone en false al cerrar por timeout
    snackShow: {
      get() {
        return this.$store.getters['notificaciones/snackShow']
      },
      set(valor) {
        if (!valor) this.hideSnack()
      }
    },

    color() {
      switch (this.type) {
        case '200':
          return 'success';
        case '201':
          return "success";
        case '500':
          return "orange darken-1";
        case '400':
          return "red";
      }
    }
  },
  methods: {
    ...mapActions('notificaciones', ['resetSnack', 'hideSnack']),
  },
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      default: '400'
    }
  }
}

</script>